/* The Salted Roots — Uses & Recipes page behaviour (sections/tsr-uses.liquid)
   Three small jobs, no dependencies:
     1. The "What are you making?" filter. Server-rendered content, JS only hides
        what does not match. The filter is kept in the URL (?making=drinks) so a
        filtered view can be sent to someone.
     2. Jar strip: smooth jump links, and the strip follows the reader (scroll spy).
     3. Two convenience links that need a target the section cannot know in
        Liquid: the recipe carousel and the footer newsletter.
   Motion: the filter change runs inside a same-document View Transition where
   the browser has one (220ms, house curve, set in section-tsr-uses.css). Not to
   be confused with the cross-page transition the theme disables on purpose. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tsr-uses]');
  if (!root) return;

  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tsr-cat]'));
  var uses = Array.prototype.slice.call(root.querySelectorAll('[data-tsr-use]'));
  var jars = Array.prototype.slice.call(root.querySelectorAll('[data-tsr-jar]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-tsr-group]'));
  var jumps = Array.prototype.slice.call(root.querySelectorAll('[data-tsr-jump]'));
  var countEl = root.querySelector('[data-tsr-count]');
  var emptyEl = root.querySelector('[data-tsr-empty]');
  var bar = root.querySelector('[data-tsr-uses-bar]');
  var strip = root.querySelector('[data-tsr-jars]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  /* ---- 1. filter -------------------------------------------------------- */
  function chipLabel(cat) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-tsr-cat') === cat) return chips[i].textContent.trim();
    }
    return '';
  }
  function apply(cat) {
    var shownUses = 0, shownJars = 0, i;
    var jarShown = {};
    for (i = 0; i < uses.length; i++) {
      var u = uses[i];
      var hit = !cat || (' ' + (u.getAttribute('data-cats') || '') + ' ').indexOf(' ' + cat + ' ') !== -1;
      u.hidden = !hit;
      /* the icon follows the active category: under Drinks a "Bloody Mary rim" row wears the
         glass, not the egg it wears when everything is showing */
      var useEl = u.querySelector('use');
      if (useEl) useEl.setAttribute('href', '#tsr-ico-' + (cat || u.getAttribute('data-icon') || 'all'));
      if (hit) {
        shownUses++;
        var jar = u.closest('[data-tsr-jar]');
        if (jar) jarShown[jar.id] = true;
      }
    }
    for (i = 0; i < jars.length; i++) {
      var j = jars[i];
      var on = !!jarShown[j.id];
      j.hidden = !on;
      if (on) shownJars++;
    }
    for (i = 0; i < groups.length; i++) {
      var g = groups[i];
      g.hidden = !g.querySelector('[data-tsr-jar]:not([hidden])');
    }
    for (i = 0; i < jumps.length; i++) {
      var target = jumps[i].getAttribute('data-tsr-jump');
      var live = !!jarShown[target];
      if (live) jumps[i].removeAttribute('aria-disabled'); else jumps[i].setAttribute('aria-disabled', 'true');
    }
    if (emptyEl) emptyEl.hidden = shownUses > 0;
    root.classList.toggle('tsr-uses--filtered', !!cat);
    if (countEl) {
      var jarsWord = shownJars === 1 ? 'jar' : 'jars';
      var ideasWord = shownUses === 1 ? 'idea' : 'ideas';
      countEl.textContent = cat
        ? chipLabel(cat) + ': ' + shownUses + ' ' + ideasWord + ' across ' + shownJars + ' ' + jarsWord + '.'
        : shownUses + ' ideas across ' + shownJars + ' jars.';
    }
  }
  function setFilter(cat, fromUser) {
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-pressed', chips[i].getAttribute('data-tsr-cat') === cat ? 'true' : 'false');
    }
    var run = function () { apply(cat); };
    if (fromUser && !reduce && typeof document.startViewTransition === 'function') {
      document.documentElement.classList.add('tsr-uses-vt');
      var t = document.startViewTransition(run);
      var done = function () { document.documentElement.classList.remove('tsr-uses-vt'); };
      if (t && t.finished) t.finished.then(done, done); else done();
    } else {
      run();
    }
    if (fromUser && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      if (cat) url.searchParams.set('making', cat); else url.searchParams.delete('making');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
  }
  for (var c = 0; c < chips.length; c++) {
    chips[c].addEventListener('click', function () { setFilter(this.getAttribute('data-tsr-cat') || '', true); });
  }
  var initial = '';
  try { initial = new URL(window.location.href).searchParams.get('making') || ''; } catch (e) {}
  if (initial && !chipLabel(initial)) initial = '';
  setFilter(initial, false);

  /* ---- phones: four uses per jar until asked ---------------------------- */
  var mores = root.querySelectorAll('[data-tsr-more]');
  for (var m = 0; m < mores.length; m++) {
    mores[m].addEventListener('click', function () {
      var jar = this.closest('[data-tsr-jar]');
      var open = jar.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.textContent = open ? this.getAttribute('data-fewer') : this.getAttribute('data-all');
      if (!open) jar.scrollIntoView({ behavior: behavior, block: 'start' });
    });
  }

  /* ---- sticky bar height -> scroll margins ------------------------------- */
  if (bar) {
    var setBarH = function () { root.style.setProperty('--u-bar-h', bar.offsetHeight + 'px'); };
    setBarH();
    window.addEventListener('resize', setBarH, { passive: true });
  }

  /* ---- sticky bar shadow ------------------------------------------------- */
  if (bar) {
    var ticking = false;
    var checkStuck = function () {
      ticking = false;
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= headerH + 1);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(checkStuck); }
    }, { passive: true });
    checkStuck();
  }

  /* ---- 2. jar strip: jumps + scroll spy ---------------------------------- */
  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: behavior, block: 'start' });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
  }
  for (var k = 0; k < jumps.length; k++) {
    jumps[k].addEventListener('click', function (e) {
      var id = this.getAttribute('data-tsr-jump');
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      if (el.hidden) setFilter('', true); /* a dimmed jar in the strip clears the filter first */
      scrollToEl(el);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }
  if ('IntersectionObserver' in window && strip) {
    var current = null;
    var setCurrent = function (id) {
      if (current === id) return;
      current = id;
      for (var i = 0; i < jumps.length; i++) {
        var on = jumps[i].getAttribute('data-tsr-jump') === id;
        if (on) jumps[i].setAttribute('aria-current', 'true'); else jumps[i].removeAttribute('aria-current');
        if (on) {
          var item = jumps[i].parentElement;
          var left = item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2;
          strip.scrollTo({ left: Math.max(0, left), behavior: behavior });
        }
      }
    };
    var spy = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) setCurrent(entries[i].target.id);
      }
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
    for (var j2 = 0; j2 < jars.length; j2++) spy.observe(jars[j2]);
  }

  /* ---- 3. links whose targets live in other sections --------------------- */
  function bindJump(selector, find) {
    var links = root.querySelectorAll(selector);
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        var el = find();
        if (!el) return; /* let the plain anchor behave as it can */
        e.preventDefault();
        scrollToEl(el);
      });
    }
  }
  bindJump('[data-tsr-recipes-link]', function () { return document.querySelector('[id*="recipe_blog_carousel"]'); });
  bindJump('[data-tsr-newsletter]', function () {
    /* The input first: querySelector with a selector list returns the first match in
       DOCUMENT order, and the section wrapper sits before its own input, so a single
       combined selector scrolled the section top into view and left the field below
       the fold on phones. */
    return document.querySelector('[id*="footer_newsletter"] input[type="email"]')
      || document.querySelector('footer input[type="email"]')
      || document.querySelector('[id*="footer_newsletter"]');
  });
})();
